module.exports = __webpack_public_path__ + "static/rfa-adi@2x-1-1024x603-e59ccde78064800aab6ab26711e0f579.png";